<template>
  <div
    class="scrollable-fade-wrapper relative overflow-hidden"
    :class="[wrapperClass, fadeDirectionClass]"
  >
    <div class="no-scrollbar flex overflow-x-auto" :class="contentClass">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';

  import { FadeDirection, SCROLLABLE_FADE_CONFIG } from './config';

  const props = withDefaults(
    defineProps<{
      wrapperClass?: string;
      contentClass?: string;
      fadeColor?: string;
      fadeDirection?: FadeDirection;
    }>(),
    {
      wrapperClass: '',
      contentClass: '',
      fadeColor: SCROLLABLE_FADE_CONFIG.DEFAULT_FADE_COLOR,
      fadeDirection: FadeDirection.RIGHT,
    },
  );

  const fadeDirectionClass = computed(() => {
    if (props.fadeDirection === FadeDirection.LEFT) return 'fade-left';
    if (props.fadeDirection === FadeDirection.FULL) return 'fade-full';
    return 'fade-right';
  });

  const fadeWidth = SCROLLABLE_FADE_CONFIG.FADE_WIDTH;
</script>

<style scoped>
  .scrollable-fade-wrapper.fade-right::after,
  .scrollable-fade-wrapper.fade-full::after {
    @apply absolute bottom-0 right-0 top-0;
    content: '';
    width: v-bind('fadeWidth');
    z-index: 1;
    background: linear-gradient(
      to right,
      transparent 0%,
      v-bind('fadeColor') 100%
    );
  }

  .scrollable-fade-wrapper.fade-left::before,
  .scrollable-fade-wrapper.fade-full::before {
    @apply absolute bottom-0 left-0 top-0;
    content: '';
    width: v-bind('fadeWidth');
    z-index: 1;
    background: linear-gradient(
      to right,
      v-bind('fadeColor') 0%,
      transparent 100%
    );
  }
</style>
